module.exports = "images/slash.2dfc629f.png";